import { render, staticRenderFns } from "./listExam.vue?vue&type=template&id=04e272ae&scoped=true"
import script from "./listExam.vue?vue&type=script&lang=js"
export * from "./listExam.vue?vue&type=script&lang=js"
import style0 from "./listExam.vue?vue&type=style&index=0&id=04e272ae&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!D:\\work\\dys\\duyisheng-admin-ui\\node_modules\\vue-loader\\lib\\runtime\\componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04e272ae",
  null
  
)

export default component.exports